import { appendReduxPart } from "infrastructure/store";

import AppLanguageSwitch from "./AppLanguageSwitch";
import { appLanguageSwitchSaga } from "./AppLanguageSwitch.saga";
import { appLanguageSwitch } from "./AppLanguageSwitch.slice";

export * from "./AppLanguageSwitch.actions";
export * from "./AppLanguageSwitch.state";
export * from "./AppLanguageSwitch.api";

appendReduxPart(
  {
    reducerName: appLanguageSwitch.name,
    reducer: appLanguageSwitch.reducer
  },
  appLanguageSwitchSaga()
);

export { AppLanguageSwitch };
